export function getLast12Months(fullYear, n) {
    const months = [];
    let date = new Date();

    if (!fullYear) date.setMonth(date.getMonth() - 1);

    for (let i = 0; i < n; i++) {
        if (fullYear) date = new Date(2000, i)
        const month = date.toLocaleDateString('pt-PT', {
            month: 'long'
        });

        const year = date.getFullYear();
        const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);

        months.push({
            month: capitalizedMonth,
            year: year
        });

        date.setMonth(date.getMonth() - 1);
    }

    return months;
}